export default class VideoPlayer {
	constructor(slide) {
		this.el = slide;
		this.video = this.el.querySelector('video');
		this.playButton = this.el.querySelector('.c-slide__toggle-play');
		this.controls = this.el.querySelector('.c-slide__video-controls');
		this.timer = null;
		this.initialLoad = true;
	}

	init() {
		// Controls tonen/verbergen op devices met hover
		if (!window.matchMedia('(any-hover: none)').matches) {
			// Initieel op niet-Chrome browsers de playknop NIET tonen
			const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
			if (this.initialLoad) {
				if (!isChrome) {
					this.hideControls();
					this.initialLoad = false;
				}
			}

			this.el.addEventListener('mousemove', e => {
				if (this.video.paused) {
					window.clearTimeout(this.timer);
					// Initieel op niet-Chrome browsers de playknop NIET tonen
					if (isChrome && !this.initialLoad) {
						this.showControls();
					}
					return;
				}

				window.clearTimeout(this.timer);

				this.initialLoad = true;
				this.showControls();

				this.timer = window.setTimeout(() => {
					this.hideControls();
				}, 1500);
			});
		}

		// Controls tonen/verbergen op devices met touchstart event
		this.controls.addEventListener('touchstart', e => {
			if (e.target && e.target.closest('button')) {
				return;
			}

			if (this.controls.classList.contains('is-active')) {
				window.clearTimeout(this.timer);

				this.hideControls();
			} else {
				this.showControls();

				this.timer = window.setTimeout(() => {
					this.hideControls();
				}, 4000);
			}
		}, { passive: true });

		this.video.addEventListener('pause', e => {
			this.playButton.classList.remove('is-playing');
			this.showControls();
		});

		this.video.addEventListener('play', e => {
			this.playButton.classList.add('is-playing');

			this.timer = window.setTimeout(() => {
				this.hideControls();
			}, 1500);
		});

		this.playButton.addEventListener('click', e => {
			this.togglePlayVideo();
		});
	}

	togglePlayVideo() {
		this.video.paused ? this.play() : this.pause();
	}

	play() {
		this.video.play();
	}

	pause() {
		this.video.pause();
	}

	showControls() {
		this.controls.classList.add('is-active');
	}

	hideControls() {
		this.controls.classList.remove('is-active');
	}
}
